import { Action, handleActions } from 'redux-actions'
import {
  getCompanySignUpCodes,
  getCompanySignUpCodesSuccess,
  getCompanySignUpCodesFail,
  createCompanySignUpCode,
  createCompanySignUpCodeSuccess,
  createCompanySignUpCodeFail,
  updateCompanySignUpCode,
  updateCompanySignUpCodeSuccess,
  updateCompanySignUpCodeFail,
  deleteCompanySignUpCode,
  deleteCompanySignUpCodeSuccess,
  deleteCompanySignUpCodeFail,
} from './SignUpCodeAdminActions'
import { SignUpCodeItem } from '../../../services/api.types'

/**
 * Sign-Up Code Admin state.
 * Stores the list of sign-up codes for the selected company.
 */
class State {
  codes: SignUpCodeItem[] = []
  loading: boolean = false
  creating: boolean = false
  updating: boolean = false
  deleting: boolean = false
}

export const signUpCodeAdmin = handleActions<State, any>(
  {
    // --- Get Sign-Up Codes ---
    [String(getCompanySignUpCodes)]: (state: State): State => ({
      ...state,
      loading: true,
    }),
    [String(getCompanySignUpCodesSuccess)]: (state: State, action: Action<any>): State => ({
      ...state,
      loading: false,
      creating: false,
      updating: false,
      deleting: false,
      codes: action.payload?.codes || [],
    }),
    [String(getCompanySignUpCodesFail)]: (state: State): State => ({
      ...state,
      loading: false,
      creating: false,
      updating: false,
      deleting: false,
      codes: [],
    }),

    // --- Create Sign-Up Code ---
    [String(createCompanySignUpCode)]: (state: State): State => ({
      ...state,
      creating: true,
    }),
    [String(createCompanySignUpCodeSuccess)]: (state: State): State => ({
      ...state,
      creating: false,
    }),
    [String(createCompanySignUpCodeFail)]: (state: State): State => ({
      ...state,
      creating: false,
    }),

    // --- Update Sign-Up Code ---
    [String(updateCompanySignUpCode)]: (state: State): State => ({
      ...state,
      updating: true,
    }),
    [String(updateCompanySignUpCodeSuccess)]: (state: State): State => ({
      ...state,
      updating: false,
    }),
    [String(updateCompanySignUpCodeFail)]: (state: State): State => ({
      ...state,
      updating: false,
    }),

    // --- Delete Sign-Up Code ---
    [String(deleteCompanySignUpCode)]: (state: State): State => ({
      ...state,
      deleting: true,
    }),
    [String(deleteCompanySignUpCodeSuccess)]: (state: State): State => ({
      ...state,
      deleting: false,
    }),
    [String(deleteCompanySignUpCodeFail)]: (state: State): State => ({
      ...state,
      deleting: false,
    }),
  },
  new State(),
)

export { State as SignUpCodeAdminState }
